import { SignIn, useClerk } from '@clerk/clerk-react';
import { msg } from '@lingui/macro';
import { useLingui } from '@lingui/react';
import { useSignInWithTicket } from '@tf/shared';
import { Center, Icon } from '@tf/ui';
import { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';

import { SimplePage } from '@/components/shared';

export const SignInRoute = () => {
	const { _ } = useLingui();
	const [params] = useSearchParams();
	const token = params.get('token');

	const { signOut } = useClerk();

	const [hasError, setHasError] = useState(false);

	const navigate = useNavigate();
	const signInWithTicket = useSignInWithTicket();

	useEffect(() => {
		if (!token || !signInWithTicket) {
			return;
		}

		signInWithTicket(token)
			.then(() => {
				navigate('/');
			})
			.catch(() => {
				setHasError(true);
			});
	}, [navigate, signInWithTicket, token]);

	const requestNewLink = async () => {
		await signOut();
		navigate('/');
	};

	if (hasError) {
		return (
			<SimplePage
				title={_(msg({ id: 'singInTokenPage.error.title', message: 'Link is expired' }))}
				action={{
					icon: <Icon.IconLink />,
					label: _(msg({ id: 'singInTokenPage.error.action', message: 'Request new link' })),
					onClick: requestNewLink,
				}}
			/>
		);
	}

	return token ? (
		<SimplePage
			icon={<Icon.IconLogin2 />}
			title={_(msg({ id: 'singInTokenPage.loadingMessage', message: 'Signing in...' }))}
		/>
	) : (
		<Center mt="20vh">
			<SignIn
				routing="path"
				path="/sign-in"
				forceRedirectUrl={window.location.origin}
				appearance={{ layout: { logoPlacement: 'none' } }}
			/>
		</Center>
	);
};
